import React, { LazyExoticComponent } from 'react';

export enum RouteEnum {
  CARS = '/cars',
  CARS_DETAILS = '/cars/:carId',
  CHATS = '/chats',
  COMMISSION_ADMINISTRATION = '/commission-administration',
  COMMISSION_CONFIGURATION = '/commission-configuration',
  COMMISSIONS = '/commissions',
  COMPONENT_DEFINITION_DETAILS = '/component-definitions/:componentDefinitionId',
  COMPONENT_DEFINITIONS = '/component-definitions',
  CONTACTS = '/contacts',
  CONTACTS_CREATE = '/contacts/create',
  CONTACTS_DETAILS = '/contacts/:contactId',
  CONTACTS_EDIT = '/contacts/:contactId/edit',
  CUSTOMERS = '/customers',
  CUSTOMERS_CREATE_BUSINESS = '/customers/create-business',
  CUSTOMERS_CREATE_FOREIGN = '/customers/create-foreign',
  CUSTOMERS_CREATE_INDIVIDUAL = '/customers/create-individual',
  CUSTOMERS_DETAILS = '/customers/:customerId',
  CUSTOMERS_EDIT = '/customers/:customerId/edit',
  DASHBOARD = '/dashboard',
  DICTIONARIES = '/dictionaries',
  EMAILS = '/emails',
  EMERGENCY_CONTACTS = '/emergency-contacts',
  EMERGENCY_CONTACTS_CREATE = '/emergency-contacts/create',
  EMERGENCY_CONTACTS_DETAILS = '/emergency-contacts/:emergencyContactId',
  EMERGENCY_CONTACTS_EDIT = '/emergency-contacts/:emergencyContactId/edit',
  FAILED_WORKFLOW_ACTIONS = '/failed-workflow-actions',
  FORBIDDEN = '/forbidden',
  LOGIN_SUCCESSFUL = '/login-successful',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = '/not-found',
  OFFER_DEFINITION_CREATE = '/offer-definitions/create',
  OFFER_DEFINITION_DETAILS = '/offer-definitions/:offerDefinitionId',
  OFFER_DEFINITIONS = '/offer-definitions',
  PROCESSES = '/processes',
  PROCESSES_DETAILS = '/processes/:processId',
  PROCESSES_DETAILS_OFFER_INSTANCE = '/processes/:processId/offer-instances/:offerInstanceId',
  RECURRING_RESERVATION_DETAILS = '/recurring-reservations/:recurringReservationId',
  RECURRING_RESERVATIONS = '/recurring-reservations',
  REPORTS = '/reports',
  RESOURCE_CALENDAR = '/resource-calendar',
  ROLES = '/roles',
  ROOT = '/',
  SUPERVISORS = '/supervisors',
  SUPPLIERS = '/suppliers',
  SUPPLIERS_DETAILS = '/suppliers/:supplierId',
  TASK_DETAILS = '/tasks/:taskId/:tab?',
  TASKS = '/tasks',
  USERS = '/users',
  WAITING_FOR_APPROVAL = '/waiting-for-approval',
}

export type BreadcrumbDefinition = {
  label: 'details' | RouteEnum;
  to?: RouteEnum;
};

export type RouteHandle = {
  breadcrumbs: BreadcrumbDefinition[];
};

export interface RouteModel {
  component: LazyExoticComponent<React.FC> | React.FC;
  handle: RouteHandle;
  load?: () => Promise<{ default: React.FC }>;
  path: RouteEnum;
}
